/**
 * @fileoverview Duration formatting helpers for lesson display.
 */

/**
 * Format a lesson duration (in seconds) for compact card-style display.
 * Lessons under one minute show seconds (e.g. "30s"); longer lessons show
 * floored whole minutes (e.g. "5m") to match the existing display style.
 *
 * @param {number|string|null|undefined} seconds - Duration in seconds.
 * @returns {string} A short, human-readable duration string.
 */
export function formatLessonDuration(seconds) {
  const s = Math.max(0, Math.round(Number(seconds) || 0));
  if (s < 60) return `${s}s`;
  return `${Math.floor(s / 60)}m`;
}
